/**
 * Ship Details Page
 * =================
 * صفحة تفاصيل الشيب
 */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTenantAuth } from '../../context/TenantAuthContext';
import { useToast } from '../../context/ToastContext';
import '../shared/PageStyles.css';

const I = {
  back: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m15 18-6-6 6-6"/></svg>,
  edit: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  map: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="10" r="3"/><path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 7 8 11.7z"/></svg>,
  clock: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  star: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
  tank: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 20V10a6 6 0 1 1 12 0v10"/><path d="M4 20h16"/><path d="M12 4v2"/></svg>,
  phone: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  orders: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  truck: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  water: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>,
  calendar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  refresh: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>,
  driver: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg>,
  assign: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>,
  star: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
};

const AVAILABILITY_COLORS = {
  online:   { label: 'متاح',     color: '#22c55e', bg: '#dcfce7' },
  busy:     { label: 'مشغول',    color: '#f59e0b', bg: '#fef3c7' },
  on_break: { label: 'استراحة', color: '#6366f1', bg: '#ede9fe' },
  offline:  { label: 'غير متاح', color: '#94a3b8', bg: '#f1f5f9' },
};

const getOpenStatus = (ship) => {
  if (ship.is_24_hours) return { isOpen: true, text: 'مفتوح 24 ساعة', color: '#10b981' };
  if (!ship.opening_time || !ship.closing_time) return { isOpen: false, text: 'غير محدد', color: '#6b7280' };
  
  const now = new Date();
  const currentTime = now.getHours() * 60 + now.getMinutes();
  const [openH, openM] = ship.opening_time.split(':').map(Number);
  const [closeH, closeM] = ship.closing_time.split(':').map(Number);
  const openTime = openH * 60 + openM;
  const closeTime = closeH * 60 + closeM;
  
  let isOpen;
  if (closeTime < openTime) {
    isOpen = currentTime >= openTime || currentTime < closeTime;
  } else {
    isOpen = currentTime >= openTime && currentTime < closeTime;
  }
  
  return { isOpen, text: isOpen ? 'مفتوح الآن' : 'مغلق', color: isOpen ? '#10b981' : '#ef4444' };
};

const ShipDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { apiCall } = useTenantAuth();
  const { success, error: showError } = useToast();
  
  const [loading, setLoading] = useState(true);
  const [ship, setShip] = useState(null);
  const [orders, setOrders] = useState([]);
  const [stats, setStats] = useState({ today: 0, week: 0, month: 0 });
  const [activeTab, setActiveTab] = useState('overview');
  const [nearbyDrivers, setNearbyDrivers] = useState([]);
  const [nearbyLoading, setNearbyLoading] = useState(false);
  const [radiusKm, setRadiusKm] = useState(10);
  const [assigningDriver, setAssigningDriver] = useState(null);
  const [assignOrderId, setAssignOrderId] = useState('');

  const loadShipDetails = useCallback(async () => {
    setLoading(true);
    try {
      const [shipData, ordersData] = await Promise.all([
        apiCall(`/tenant/ship-requirements/ships/${id}`),
        apiCall(`/tenant/ships/${id}/orders?limit=10`).catch(() => ({ items: [] }))
      ]);
      setShip(shipData);
      setOrders(ordersData.items || []);
      setStats({
        today: ordersData.today_count || 0,
        week: ordersData.week_count || 0,
        month: ordersData.month_count || 0
      });
    } catch (err) {
      showError('فشل تحميل بيانات الشيب');
    } finally {
      setLoading(false);
    }
  }, [apiCall, id, showError]);

  const loadNearbyDrivers = useCallback(async () => {
    setNearbyLoading(true);
    try {
      const token = localStorage.getItem('watrly_tenant_token');
      const res = await fetch(
        `http://localhost:8002/api/v1/tenant/drivers/nearby?ship_id=${id}&radius_km=${radiusKm}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      const data = await res.json();
      setNearbyDrivers(data.drivers || []);
    } catch (err) {
      showError('فشل تحميل السائقين القريبين');
    } finally {
      setNearbyLoading(false);
    }
  }, [id, radiusKm, showError]);

  const handleAssignDriver = async (driverId) => {
    if (!assignOrderId.trim()) {
      showError('أدخل رقم الطلب أولاً');
      return;
    }
    setAssigningDriver(driverId);
    try {
      const token = localStorage.getItem('watrly_tenant_token');
      const res = await fetch(
        `http://localhost:8002/api/v1/tenant/orders/${assignOrderId}/assign`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ driver_id: driverId })
        }
      );
      if (!res.ok) throw new Error();
      setNearbyDrivers(prev => prev.map(d =>
        d.id === driverId ? { ...d, availability_status: 'busy' } : d
      ));
      setAssignOrderId('');
      success('تم تعيين السائق بنجاح');
    } catch {
      showError('فشل تعيين السائق');
    } finally {
      setAssigningDriver(null);
    }
  };

  useEffect(() => { loadShipDetails(); }, [loadShipDetails]);

  if (loading) {
    return <div className="page"><div className="page-loading"><div className="spinner" /></div></div>;
  }

  if (!ship) {
    return (
      <div className="page">
        <div className="page-empty">
          {I.tank}
          <h3>لم يتم العثور على الشيب</h3>
          <button className="btn btn--primary" onClick={() => navigate('/tenant/ships')}>العودة للقائمة</button>
        </div>
      </div>
    );
  }

  const openStatus = getOpenStatus(ship);

  return (
    <div className="page ship-details">
      {/* Header */}
      <div className="ship-details__header">
        <button className="ship-details__back" onClick={() => navigate('/tenant/ships')}>
          {I.back}
          <span>العودة</span>
        </button>
        <div className="ship-details__title">
          <div className="ship-details__name-row">
            <h1>{ship.name_ar || ship.name}</h1>
            <span className={`ship-details__status ship-details__status--${ship.status || 'active'}`}>
              {ship.status === 'active' ? 'نشط' : ship.status === 'maintenance' ? 'صيانة' : ship.status === 'closed' ? 'مغلق' : 'نشط'}
            </span>
          </div>
          <div className="ship-details__meta">
            <span className="ship-details__code">كود: {ship.code || ship.ship_code || '-'}</span>
            <span className="ship-details__approval">
              حالة الموافقة: {ship.approval_status === 'approved' ? '✅ معتمد' : ship.approval_status === 'pending' ? '⏳ قيد المراجعة' : ship.approval_status === 'rejected' ? '❌ مرفوض' : '⏳ قيد المراجعة'}
            </span>
          </div>
        </div>
        <div className="ship-details__actions">
          <button className="btn btn--secondary" onClick={loadShipDetails}>
            {I.refresh}
          </button>
          <button className="btn btn--primary" onClick={() => navigate(`/tenant/ships/edit/${id}`)}>
            {I.edit}
            <span>تعديل</span>
          </button>
        </div>
      </div>

      {/* Status Cards */}
      <div className="ship-details__cards">
        <div className="status-card">
          <div className="status-card__icon" style={{ background: 'rgba(16, 185, 129, 0.1)', color: '#10b981' }}>
            {I.tank}
          </div>
          <div className="status-card__content">
            <span className="status-card__label">المخزون الحالي</span>
            <span className="status-card__value">{ship.current_stock_tons || ship.capacity_daily_tons || 0} طن</span>
            <span className="status-card__sub">السعة: {ship.capacity_daily_tons || 0} طن</span>
          </div>
        </div>

        <div className="status-card">
          <div className="status-card__icon" style={{ background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6' }}>
            {I.orders}
          </div>
          <div className="status-card__content">
            <span className="status-card__label">طلبات اليوم</span>
            <span className="status-card__value">{stats.today}</span>
            <span className="status-card__sub">{stats.month} هذا الشهر</span>
          </div>
        </div>

        <div className="status-card">
          <div className="status-card__icon" style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b' }}>
            {I.star}
          </div>
          <div className="status-card__content">
            <span className="status-card__label">التقييم</span>
            <span className="status-card__value">{ship.rating_avg ? Number(ship.rating_avg).toFixed(1) : '5.0'}</span>
            <span className="status-card__sub">{ship.total_orders || 0} طلب</span>
          </div>
        </div>

        <div className="status-card">
          <div className="status-card__icon" style={{ background: openStatus.isOpen ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)', color: openStatus.color }}>
            {I.clock}
          </div>
          <div className="status-card__content">
            <span className="status-card__label">ساعات العمل</span>
            <span className="status-card__value" style={{ color: openStatus.color }}>{openStatus.text}</span>
            <span className="status-card__sub">
              {ship.is_24_hours ? 'يعمل طوال اليوم' : `${ship.opening_time || '--:--'} - ${ship.closing_time || '--:--'}`}
            </span>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="ship-details__tabs">
        <button className={`ship-details__tab ${activeTab === 'overview' ? 'active' : ''}`} onClick={() => setActiveTab('overview')}>نظرة عامة</button>
        <button className={`ship-details__tab ${activeTab === 'orders' ? 'active' : ''}`} onClick={() => setActiveTab('orders')}>الطلبات</button>
        <button className={`ship-details__tab ${activeTab === 'drivers' ? 'active' : ''}`} onClick={() => { setActiveTab('drivers'); loadNearbyDrivers(); }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" style={{display:'inline',verticalAlign:'middle',marginLeft:'4px'}}><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg>
          السائقين القريبين
        </button>
        <button className={`ship-details__tab ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => setActiveTab('settings')}>الإعدادات</button>
      </div>

      {/* Tab Content */}
      <div className="ship-details__content">
        {activeTab === 'overview' && (
          <div className="ship-details__overview">
            {/* Location Info */}
            <div className="info-card">
              <h3 className="info-card__title">{I.map} معلومات الموقع</h3>
              <div className="info-card__grid">
                <div className="info-item">
                  <span className="info-item__label">المنطقة</span>
                  <span className="info-item__value">{ship.region || '-'}</span>
                </div>
                <div className="info-item">
                  <span className="info-item__label">المدينة</span>
                  <span className="info-item__value">{ship.city || '-'}</span>
                </div>
                <div className="info-item">
                  <span className="info-item__label">الحي</span>
                  <span className="info-item__value">{ship.district || '-'}</span>
                </div>
                <div className="info-item">
                  <span className="info-item__label">الشارع</span>
                  <span className="info-item__value">{ship.street || '-'}</span>
                </div>
                <div className="info-item full">
                  <span className="info-item__label">العنوان الكامل</span>
                  <span className="info-item__value">{ship.address || '-'}</span>
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="info-card">
              <h3 className="info-card__title">{I.phone} معلومات التواصل</h3>
              <div className="info-card__grid">
                <div className="info-item">
                  <span className="info-item__label">رقم الهاتف</span>
                  <span className="info-item__value">{ship.contact_phone || '-'}</span>
                </div>
                <div className="info-item">
                  <span className="info-item__label">رقم إضافي</span>
                  <span className="info-item__value">{ship.secondary_phone || '-'}</span>
                </div>
              </div>
            </div>

            {/* Working Hours */}
            <div className="info-card">
              <h3 className="info-card__title">{I.clock} ساعات العمل</h3>
              <div className="info-card__grid">
                <div className="info-item">
                  <span className="info-item__label">وقت الفتح</span>
                  <span className="info-item__value">{ship.is_24_hours ? '24 ساعة' : ship.opening_time || '-'}</span>
                </div>
                <div className="info-item">
                  <span className="info-item__label">وقت الإغلاق</span>
                  <span className="info-item__value">{ship.is_24_hours ? '24 ساعة' : ship.closing_time || '-'}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'drivers' && (
          <div className="ship-details__drivers">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <label style={{ fontSize: '14px', color: 'var(--tenant-text-muted)' }}>نطاق البحث:</label>
                <select
                  value={radiusKm}
                  onChange={(e) => setRadiusKm(Number(e.target.value))}
                  style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid var(--tenant-border)', background: 'var(--tenant-card-bg)', color: 'var(--tenant-text)' }}
                >
                  {[2, 5, 10, 15, 20, 30, 50].map(r => <option key={r} value={r}>{r} كم</option>)}
                </select>
              </div>
              <button className="btn btn--secondary btn--sm" onClick={loadNearbyDrivers} disabled={nearbyLoading}>
                {I.refresh} {nearbyLoading ? 'جاري التحديث...' : 'تحديث'}
              </button>
              <span style={{ fontSize: '13px', color: 'var(--tenant-text-muted)', marginRight: 'auto' }}>
                {nearbyDrivers.length} سائق متاح ضمن {radiusKm} كم
              </span>
            </div>

            <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px', background: 'var(--tenant-card-bg)', padding: '12px', borderRadius: '10px', border: '1px solid var(--tenant-border)' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', whiteSpace: 'nowrap' }}>رقم الطلب للتعيين:</label>
              <input
                type="text"
                value={assignOrderId}
                onChange={(e) => setAssignOrderId(e.target.value)}
                placeholder="أدخل ID الطلب..."
                style={{ flex: 1, padding: '8px 12px', borderRadius: '8px', border: '1px solid var(--tenant-border)', background: 'var(--tenant-bg)', color: 'var(--tenant-text)', fontSize: '14px' }}
                dir="ltr"
              />
            </div>

            {nearbyLoading ? (
              <div className="page-loading"><div className="spinner" /></div>
            ) : nearbyDrivers.length === 0 ? (
              <div className="empty-state">
                {I.driver}
                <h4>لا يوجد سائقون متاحون في هذا النطاق</h4>
                <p style={{ fontSize: '13px', color: 'var(--tenant-text-muted)' }}>
                  تأكد أن السائقين فعّلوا حالتهم إلى "متاح" وأرسلوا موقعهم
                </p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {nearbyDrivers.map(d => {
                  const avail = AVAILABILITY_COLORS[d.availability_status] || AVAILABILITY_COLORS.offline;
                  return (
                    <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: '16px', background: 'var(--tenant-card-bg)', padding: '16px', borderRadius: '12px', border: '1px solid var(--tenant-border)' }}>
                      <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '700', flexShrink: 0 }}>
                        {d.full_name?.charAt(0)}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                          <span style={{ fontWeight: '600', fontSize: '15px' }}>{d.full_name}</span>
                          <span style={{ padding: '2px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', background: avail.bg, color: avail.color }}>
                            {avail.label}
                          </span>
                          <span style={{ fontSize: '13px', color: '#6366f1', fontWeight: '600' }}>
                            📍 {d.distance_km} كم
                          </span>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', marginTop: '4px', fontSize: '13px', color: 'var(--tenant-text-muted)', flexWrap: 'wrap' }}>
                          <span dir="ltr">{d.phone}</span>
                          {d.rating && <span>⭐ {d.rating.toFixed(1)}</span>}
                          {d.vehicle && <span>🚛 {d.vehicle.plate} - {d.vehicle.make} {d.vehicle.model}</span>}
                          {d.last_seen && <span>آخر تحديث: {new Date(d.last_seen).toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' })}</span>}
                        </div>
                      </div>
                      <button
                        className="btn btn--primary btn--sm"
                        onClick={() => handleAssignDriver(d.id)}
                        disabled={assigningDriver === d.id || !assignOrderId.trim()}
                        style={{ flexShrink: 0 }}
                      >
                        {assigningDriver === d.id ? '...' : <>{I.assign} تعيين</>}
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {activeTab === 'orders' && (
          <div className="ship-details__orders">
            {orders.length === 0 ? (
              <div className="empty-state">
                {I.orders}
                <h4>لا توجد طلبات حتى الآن</h4>
              </div>
            ) : (
              <div className="orders-list">
                {orders.map(order => (
                  <div key={order.id} className="order-item">
                    <div className="order-item__info">
                      <span className="order-item__id">#{order.order_number || order.id}</span>
                      <span className="order-item__date">{new Date(order.created_at).toLocaleDateString('ar-SA')}</span>
                    </div>
                    <div className="order-item__details">
                      <span>{order.quantity_liters || 0} لتر</span>
                      <span className={`order-status order-status--${order.status}`}>
                        {order.status === 'completed' ? 'مكتمل' : order.status === 'pending' ? 'قيد الانتظار' : order.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'settings' && (
          <div className="ship-details__settings">
            <div className="info-card">
              <h3 className="info-card__title">إعدادات الشيب</h3>
              <div className="info-card__grid">
                <div className="info-item">
                  <span className="info-item__label">حالة الشيب</span>
                  <span className={`badge badge--${ship.status === 'active' ? 'success' : 'danger'}`}>
                    {ship.status === 'active' ? 'نشط' : ship.status === 'maintenance' ? 'صيانة' : 'مغلق'}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-item__label">السعة اليومية</span>
                  <span className="info-item__value">{ship.capacity_daily_tons || 0} طن</span>
                </div>
                <div className="info-item">
                  <span className="info-item__label">تاريخ الإنشاء</span>
                  <span className="info-item__value">{new Date(ship.created_at).toLocaleDateString('ar-SA')}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style>{`
        .ship-details__header {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-wrap: wrap;
        }
        
        .ship-details__back {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 12px;
          border: none;
          background: var(--tenant-bg);
          border-radius: 8px;
          color: var(--tenant-text-muted);
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .ship-details__back:hover {
          background: var(--tenant-border);
          color: var(--tenant-text);
        }
        
        .ship-details__back svg {
          width: 18px;
          height: 18px;
        }
        
        .ship-details__title {
          flex: 1;
        }
        
        .ship-details__title h1 {
          font-size: 24px;
          font-weight: 700;
          color: var(--tenant-text);
          margin: 0;
        }
        
        .ship-details__name-row {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        
        .ship-details__status {
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }
        
        .ship-details__status--active {
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
        }
        
        .ship-details__status--maintenance {
          background: rgba(245, 158, 11, 0.1);
          color: #f59e0b;
        }
        
        .ship-details__status--closed {
          background: rgba(239, 68, 68, 0.1);
          color: #ef4444;
        }
        
        .ship-details__meta {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-top: 8px;
          flex-wrap: wrap;
        }
        
        .ship-details__code {
          font-size: 13px;
          color: var(--tenant-text-muted);
          font-family: monospace;
          background: var(--tenant-bg);
          padding: 4px 10px;
          border-radius: 6px;
        }
        
        .ship-details__approval {
          font-size: 13px;
          color: var(--tenant-text-muted);
        }
        
        .ship-details__actions {
          display: flex;
          gap: 8px;
        }
        
        .ship-details__cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          margin-top: 24px;
        }
        
        .status-card {
          background: var(--tenant-card-bg);
          border-radius: 12px;
          padding: 20px;
          display: flex;
          gap: 16px;
          align-items: flex-start;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }
        
        .status-card__icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .status-card__icon svg {
          width: 24px;
          height: 24px;
        }
        
        .status-card__content {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        
        .status-card__label {
          font-size: 13px;
          color: var(--tenant-text-muted);
        }
        
        .status-card__value {
          font-size: 22px;
          font-weight: 700;
          color: var(--tenant-text);
        }
        
        .status-card__sub {
          font-size: 12px;
          color: var(--tenant-text-muted);
        }
        
        .ship-details__tabs {
          display: flex;
          gap: 4px;
          background: var(--tenant-bg);
          padding: 4px;
          border-radius: 10px;
          margin-top: 24px;
        }
        
        .ship-details__tab {
          padding: 10px 20px;
          border: none;
          background: none;
          border-radius: 8px;
          font-size: 14px;
          color: var(--tenant-text-muted);
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .ship-details__tab:hover {
          color: var(--tenant-text);
        }
        
        .ship-details__tab.active {
          background: var(--tenant-card-bg);
          color: var(--tenant-primary);
          font-weight: 500;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .ship-details__content {
          margin-top: 20px;
        }
        
        .ship-details__overview {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        
        .info-card {
          background: var(--tenant-card-bg);
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }
        
        .info-card__title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 16px;
          font-weight: 600;
          color: var(--tenant-text);
          margin: 0 0 16px;
          padding-bottom: 12px;
          border-bottom: 1px solid var(--tenant-border);
        }
        
        .info-card__title svg {
          width: 20px;
          height: 20px;
          color: var(--tenant-primary);
        }
        
        .info-card__grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 16px;
        }
        
        .info-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        
        .info-item.full {
          grid-column: 1 / -1;
        }
        
        .info-item__label {
          font-size: 12px;
          color: var(--tenant-text-muted);
        }
        
        .info-item__value {
          font-size: 14px;
          color: var(--tenant-text);
          font-weight: 500;
        }
        
        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          background: var(--tenant-card-bg);
          border-radius: 12px;
          color: var(--tenant-text-muted);
        }
        
        .empty-state svg {
          width: 48px;
          height: 48px;
          margin-bottom: 16px;
          opacity: 0.5;
        }
        
        .empty-state h4 {
          margin: 0;
          font-size: 16px;
        }
        
        .orders-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        
        .order-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;
          background: var(--tenant-card-bg);
          border-radius: 10px;
          border: 1px solid var(--tenant-border);
        }
        
        .order-item__info {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        
        .order-item__id {
          font-weight: 600;
          color: var(--tenant-text);
        }
        
        .order-item__date {
          font-size: 12px;
          color: var(--tenant-text-muted);
        }
        
        .order-item__details {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .order-status {
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }
        
        .order-status--completed {
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
        }
        
        .order-status--pending {
          background: rgba(245, 158, 11, 0.1);
          color: #f59e0b;
        }
        
        @media (max-width: 768px) {
          .ship-details__header {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .ship-details__actions {
            width: 100%;
          }
          
          .ship-details__actions .btn {
            flex: 1;
          }
          
          .ship-details__cards {
            grid-template-columns: 1fr 1fr;
          }
          
          .ship-details__tabs {
            overflow-x: auto;
          }
        }
        
        @media (max-width: 480px) {
          .ship-details__cards {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default ShipDetailsPage;
